import { render } from "./PersonIcon.vue?vue&type=template&id=4b0fd0fc"
const script = {}
script.render = render

export default script